import {
    apiRequest,
    levelTunjanganKhususDetail, 
    levelTunjanganKhususUpdate,
} from "../../../../../services/adapters/master/levelTunjanganKhususService"

class IndexRepository {
    fetchDetail = async (query) => {
        return await apiRequest("get", levelTunjanganKhususDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", levelTunjanganKhususUpdate, {
            body: query
        }, true)
    }

}

export default IndexRepository